// NOTICE:
// The upstream default here was `https://api.airi.build`, which meant this
// deployment called upstream's account service on every page load — a request to
// third-party infrastructure carrying our users' origin, failing CORS, and
// logging an error on the console of a page that is meant to have no upstream
// dependency at all. Observed live at https://aura.luminacorp.io:
//   "Access to fetch at 'https://api.airi.build/api/auth/get-session' from origin
//    'https://aura.luminacorp.io' has been blocked by CORS policy".
//
// Lumina does not run better-auth. Sessions come from the platform JWT, which
// `stores/providers/lumina-session.ts` already resolves, and the proxy validates.
// Pointing the default at our own origin keeps every auth request inside the
// platform: `/api/auth/get-session` answers 404 there, which is a local, honest
// failure rather than traffic leaving for a third party.
//
// Removal condition: Phase 2 wires this to the real credential endpoint
// (`GET /api/auth/jwt/credentials` on CHEF). Set VITE_SERVER_URL to override
// without a code change in the meantime.
export const SERVER_URL = import.meta.env.VITE_SERVER_URL || 'https://luminacorp.io'
